import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Trade } from '../../../core/models/decision-tree.model';

@Component({
  selector: 'app-trade-picker',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './trade-picker.component.html',
  styleUrl: './trade-picker.component.scss',
})
export class TradePickerComponent {
  @Input({ required: true }) trades: Trade[] = [];
  @Output() picked = new EventEmitter<Trade>();

  glyphFor(name: string): string {
    return name
      .split(/[\s\-/]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((w) => w[0] ?? '')
      .join('')
      .toUpperCase();
  }
}
